export default __webpack_public_path__ + "static/media/j.65491b1d.png";